import IconosGenerales from '../iconos/IconosGenerales';
import React from 'react';
import Boton from '../eventos/Boton';
import Card from 'react-bootstrap/Card';
import styled from 'styled-components';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import ImagenDefault from './../../img/imgDefault.png';


function transformarTexto(texto) {
    return texto
        .normalize("NFD") 
        .replace(/[\u0300-\u036f]/g, "") 
        .replace(/\s+/g, "-"); 
}

//apratado de las caracteritícas de cada curso
const CursoContacto = ({ curso }) => {
    // function handleClick(event) {
    //     event.preventDefault();
    //     console.info('You clicked a breadcrumb.');
    // }

    const listadoRequisitos = curso.Requisito.descripcion;
    const arrayRequisitos = listadoRequisitos.split(',');
    const currentUrl = decodeURIComponent(window.location.pathname);
    const urlSegments = currentUrl.split('/').filter(segment => segment !== '');
    // Filtra solo los últimos tres segmentos
    // console.log(currentUrl);
    const buildLinks = () => {
        let currentPath = '';
        return urlSegments.map((segment, index) => {
            currentPath += `/${segment}`;
            // console.log(segment);
            if (segment !== "cursos") {
                return (
                    <Link underline="hover" color="inherit" href={currentPath}>
                        {segment}
                    </Link>
                );
            }
            return null;
        });
    };
    return (
        <>
            <EncabezadoCurso>
                <div role="presentation" className='menu-bar'>
                    <Breadcrumbs maxItems={2} aria-label="breadcrumb" >
                        {buildLinks()}
                    </Breadcrumbs>
                </div>
                <h1>{curso.nombre.replace(/-/g, " ")}</h1>
                <Parrafo color="gris">{curso.Categoria[0].categoria.replace(/-/g, " ")}</Parrafo>
                <Parrafo color="naranja">Nivel {curso.nivel} </Parrafo>
            </EncabezadoCurso>
            <CardCurso>
                <CardHeader><Card.Title><IconosGenerales id="reloj" />{curso.horas}h</Card.Title></CardHeader>
                <Card.Img variant="top" src={curso.img? transformarTexto(curso.img): ImagenDefault}  onError={(e) => { e.target.src = ImagenDefault; }} />
                <CuerpoCard >
                    <IconosGenerales id="libro" curso="true" />
                    <Boton
                        to={curso.temario}
                        target="_blank"
                    >VER TEMARIO</Boton>
                </CuerpoCard >
            </CardCurso>
            <Requisitos>
                <TituloR>Requisitos</TituloR>

                <ListadoR>

                    {arrayRequisitos.map((requisito, index) => (
                        <li key={index}><IconosGenerales id="check" />{requisito}</li>
                    ))}


                </ListadoR>
            </Requisitos>
        </>
    );
}

export default CursoContacto;

const EncabezadoCurso = styled.div`
  
    h1{
        font-family: 'Montserrat';
        font-weight: 1000;
        font-size: 28px;
        text-transform: uppercase;
    }

    p{
        text-transform: capitalize;
        font-family: 'Montserrat';
        font-size: 17px;
        font-weight: 400;
        font-style: italic;
        line-height: 1em;   

    }

`

const Parrafo = styled.p`
    color: ${(props) => (props.color === "gris" ? "#7A7A7A" : props.color === "naranja" ? "#EE805D" : "black")};

`
const CardCurso = styled(Card)`
    width: '90%' ;
    border: none !important;
`;
const CardHeader = styled(Card.Header)`
    border: none !important;
    margin-bottom: 10px !important;
`;
const CuerpoCard = styled(Card.Body)`
    margin-left: -20px !important;

`;
const Requisitos = styled.div`
    margin-right: 10px;
`
const TituloR = styled.p`
    background-color: #EE805D;
    color: #fff;
    margin: 10px 0px 0px 0px;
    padding: 2px 10px;
    display: block;
    width: 100%;
    font-size: 20px;
    font-weight: 600;

`
const ListadoR = styled.ul`
    display: inline-block;
    padding: 3% 0% 0% 5%;
    list-style: none;

`